import moment from 'moment';
import { getHistoryChartType, getHistoryEventType } from 'services/SensorHelper';
import { ConfigHelper, DataConverter } from 'services/charting';
import ConfigPresets from 'services/charting/presets';
import { AbstractChartController } from '../chart-abstract-base';

/* eslint class-methods-use-this: 0 */

/* @ngInject */
export default class ChartDifferentialPressureController extends AbstractChartController {
    constructor(SensorEventsLoader, ToastService, $scope,EventEmitter) {
        super({
            SensorEventsLoader,
            ToastService,
            $rootScope: $scope.$root,
            EventEmitter,
        });
    }

    // Overrides AbstractChartController
    get dataSeries() {
        return {
            addPoint: (pascal, timestamp) => {
                this.chart.series[0].addPoint([timestamp, pascal], false);
            },
            setData: (data) => {
                this.chart.series[0].setData(data.map(item => [item[0], item[1]]));
            }
        }
    }

    // Overrides AbstractChartController
    getEventTypes() {
        return [this.eventType];
    }

    // Overrides AbstractChartController
    getConfigPreset() {
        return ConfigPresets.DifferentialPressure;
    }

    // Overrides AbstractChartController
    convertToSeries(data, spacerStart, spacerEnd, spacerMin, spacerMax) {
        return ConfigHelper.differentialPressureSeries(
            data,
            spacerStart,
            spacerEnd,
            spacerMin,
            spacerMax
        );
    }

    // Overrides AbstractChartController
    convertEvents(events) {
        const eventTimestamps = events.map(e => moment(e.data.differentialPressure.updateTime).valueOf())

        this.plotBands = DataConverter.createOfflineBands(
            eventTimestamps,
            this.chartMin,
            this.chartMax
        );

        this.chartData = DataConverter.syncOfflineTemperature(
            DataConverter.differentialPressure(events),
            this.plotBands
        );

        return {
            data: this.chartData,
            plotBands: this.plotBands
        };
    }

    // Overrides AbstractChartController
    onStateEventReceived({ samples, updateTime }) {
        const timestamp = +new Date(updateTime);
        const value = DataConverter.pascalToUserPreference(samples[0].pascal);

        this.adjustMinMaxValues(value);
        this.dataSeries.addPoint(value, timestamp);
    }

    adjustMinMaxValues(value) {
        if (value < this.spacerMin) {
            this.spacerMin = value;
        } else if (value > this.spacerMax) {
            this.spacerMax = value;
        }
    }

    $onInit() {
        this.chartType = getHistoryChartType(this.thing);
        this.eventType = getHistoryEventType(this.thing);
        super.$onInit();
    }
}
